import React from "react";

export default function PrivacyPolicy() {
  return <div>Privacy Policy</div>;
}
